import { WatchManager } from "./class/watch/watchManager.class";
import './index.css';
var watchManager = new WatchManager();
